import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "../lib/api";
import { SiteLayout } from "../components/site/SiteLayout";
import { LifeThemes, useLifePublic } from "../components/site/LifeShowcase";
import { SpeakTopics, useSpeakPublic } from "../components/site/SpeakShowcase";

export default function Stories() {
  const [stories, setStories] = useState([]);
  const life = useLifePublic();
  const speak = useSpeakPublic();
  useEffect(() => { api.get("/public/stories").then(({ data }) => setStories(data)).catch(() => {}); }, []);
  return (
    <SiteLayout>
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-14 font-serif-tc" data-testid="stories-page">
        <h1 className="text-4xl sm:text-5xl font-black text-[var(--vermilion)]">故事總覽</h1>
        <p className="text-lg text-stone-700 mt-4">小書童有五座學習館：經典故事館、生活中文館、我會說中文館、注音練習館和小書童畫坊，各有自己的課程和進度。</p>
        <h2 className="text-3xl font-black text-[var(--tea)] mt-12" data-testid="stories-classic-title">經典故事館</h2>
        <p className="text-stone-600 mt-2">完成一個故事，就會解鎖下一個地方。</p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
          {stories.map((s, i) => (
            <motion.div key={s.story_id} data-testid={`story-card-${s.story_id}`} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: (i % 3) * 0.08 }} className="scroll-card overflow-hidden">
              <div className="relative">
                <img src={s.thumbnail} alt="" className="h-48 w-full object-cover" />
                <span className="absolute top-3 left-3 seal px-3 py-1 font-black">第{s.story_number}課</span>
                <span className="absolute bottom-3 right-3 text-4xl drop-shadow">{s.sticker}</span>
              </div>
              <div className="p-5">
                <div className="text-sm text-stone-500">{s.map_location}</div>
                <div className="text-3xl font-black mt-1">{s.story_title}</div>
                <p className="text-stone-600 mt-2">{s.description_zh}</p>
                <div className="mt-3 text-sm text-[var(--tea)]">完成徽章：🏅 {s.badge_name}</div>
              </div>
            </motion.div>
          ))}
        </div>
        <h2 className="text-3xl font-black text-[#2c6e65] mt-16 font-round" data-testid="stories-life-title">生活中文館</h2>
        <p className="text-stone-600 mt-2 mb-6 font-round text-lg">八個生活主題，每個主題三個原創小故事。</p>
        <LifeThemes themes={life?.themes} showStories />
        <h2 className="text-3xl font-black text-[#8F3520] mt-16 font-round" data-testid="stories-speak-title">我會說中文館</h2>
        <p className="text-stone-600 mt-2 mb-6 font-round text-lg">十二個生活情境，每課十句實用中文：聽一聽、選一選、跟著說、錄下來比一比。</p>
        <SpeakTopics topics={speak?.topics} />
        <h2 className="text-3xl font-black text-[#B4471F] mt-16 font-round" data-testid="stories-art-title">小書童畫坊</h2>
        <p className="text-stone-600 mt-2 mb-6 font-round text-lg">10 個塗色、10 個跟著畫、6 個中華文化美術、5 個經典故事角色創作，還有自由畫板和我的小畫廊。文化與故事活動都附有典故旁白。</p>
        <div className="grid grid-cols-3 sm:grid-cols-6 gap-3" data-testid="stories-art-preview">
          {[["k01", "紅燈籠"], ["k02", "十二生肖"], ["k06", "紙傘"], ["s01", "曹沖的大象"], ["s03", "司馬光砸缸"], ["s05", "畫蛇添足"]].map(([k, t]) => (
            <div key={k} className="rounded-2xl bg-white border-2 border-[#f7c6d2] p-2 text-center">
              <img src={`${process.env.REACT_APP_BACKEND_URL}/api/art/line/${k}.png`} alt={t} className="aspect-square w-full object-contain" />
              <div className="text-sm font-bold text-stone-600 mt-1 truncate">{t}</div>
            </div>
          ))}
        </div>
      </div>
    </SiteLayout>
  );
}
